function cobrowsingInit({ co_browsing_guest_id, co_browsing_sub_account_id }) {
    if (!co_browsing_sub_account_id) {
        return
    }

    !(function() {
        var e = (window.Median = window.Median || [])

        if (!e._initialized)
            if (e._snippet_loaded) console.warn('Median Snippet loaded twice.')
            else {
                ;(e._snippet_loaded = !0),
                    (e._snippet_version = 3),
                    (e.methods = [
                        'init',
                        'identify',
                        'endSession',
                        'on',
                        'grantPermission',
                        'denyPermission',
                        'endActionControl',
                        'denyAction',
                        'grantAction'
                    ]),
                    (e.factory = function(n) {
                        return function() {
                            var t = Array.prototype.slice.call(arguments)
                            try {
                                e?.push([n, t])
                            } catch {
                                console.log('Median Catch')
                            }
                        }
                    })
                for (var n = 0; n < e.methods.length; n++) {
                    var t = e.methods[n]
                    e[t] = e.factory(t)
                }
                var i = document.createElement('script')
                ;(i.type = 'text/javascript'),
                    (i.src = 'https://js.hellomedian.com/v1/mdn-screenshare.js')
                var a = document.getElementsByTagName('script')[0]
                a.parentNode.insertBefore(i, a)
            }
    })()

    window.Median.identify(co_browsing_guest_id)

    window.Median.init(co_browsing_sub_account_id)

    window.Median.on('sessionStarted', function() {
        console.log('Median Session Started')
    })
    window.Median.on('sessionEnded', function() {
        console.log('Median Session Ended')
    })
}

export default cobrowsingInit
